<template>
  <div>
    <HeaderComp />
    <div class="content">
      <p>{AUTO24_CONTENT}</p>
      <a href="https://www.auto24.ee/api/mlrehvid/parts/?cid=64"
        >Auto24 Otsing</a
      >
    </div>
    <FooterComp />
  </div>
</template>

<script>
import HeaderComp from "@/components/HeaderComp.vue";
import FooterComp from "@/components/FooterComp.vue";

export default {
  name: "Auto24",
  components: {
    HeaderComp,
    FooterComp,
  },
};
</script>

<style scoped>
.content {
  text-align: center;
  margin: 20px;
}
</style>
